import { Button } from '@mui/material';
// import { Map } from '@mui/icons-material';
import { H5, Body2, Body3 } from '../../themes/typography';

export default function VenueLocationSection({
    venueName = 'Venue Name',
    address = '123 Main St, Springfield, USA',
    latitude = 21.1754615,
    longitude = 72.7830602
}) {
    return (
        <div className="event-preview-venue-location-container">
            <H5 fontWeight={700}>Venue Location</H5>

            <div className="event-preview-venue-location-details">
                <div className="event-preview-venue-location">
                    <Body2 fontWeight={400}>{venueName}</Body2>
                    <Body3 fontWeight={300}>{address}</Body3>
                </div>

                <div className="event-preview-venue-map-direction">
                    <Button
                        // variant="toggleActive"
                        // endIcon={<Map />}
                        href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
                        target="_blank"
                        sx={{
                            color: 'var(--quaternary-color)',
                            textDecoration: 'underline',
                            fontSize: '1rem',
                        }}
                    >
                        View on map
                    </Button>
                </div>
            </div>
        </div>
    );
}
